const initialState = [];

export const bpParticipantsReducer = (state = initialState, action) => {
    if (action.type === 'SET_BP_PARTICIPANTS') {
        return [...state, action.payload]
    } else if (action.type === 'UPDATE_BP_PARTICIPANTS') {
        return state.map((item) => {
            if (item.idPeserta === action.payload.idPeserta) {
                return { ...item, ...action.payload }
            }
            return item
        })
    } else if (action.type === 'REMOVE_BP_PARTICIPANTS') {
        return state.filter((item) => item.idPeserta !== action.payload.idPeserta);
    } else if (action.type === 'UNSET_BP_PARTICIPANT_IN_PROGRAM') {
        return state.filter((item) => item.bpiId !== action.payload.bpiId);
    }
    return state
}